//Modules
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'

//Components
import AgendaItem from './AgendaItem';

//Utils
import useFetch from "../../utils/useFetch";

const { 
        REACT_APP_CACHE_API_ROOT,
        REACT_APP_CACHE_API_ENDPOINT,
        REACT_APP_CACHE_API_DATA_ENDPOINT,
        REACT_APP_CACHE_API_DATA_IPBNEWS_ENDPOINT,
        REACT_APP_CACHE_API_DATA_EVENTS_ENDPOINT
     } = process.env

const AgendaCache = ({ elmt, lang }) => {
    
    const { data: AgendaCache, loading } = useFetch(`${REACT_APP_CACHE_API_ROOT}${REACT_APP_CACHE_API_ENDPOINT}${REACT_APP_CACHE_API_DATA_ENDPOINT}${REACT_APP_CACHE_API_DATA_IPBNEWS_ENDPOINT}${REACT_APP_CACHE_API_DATA_EVENTS_ENDPOINT}`)
    console.log("Cache API in use!!!")

    const yesterday = new Date()
    yesterday.setDate(yesterday.getDate() - 1)

    let agendaFilter = (!loading || AgendaCache !== null) &&
        AgendaCache.filter((agendaItem) => {                  
            if ((agendaItem.destaque === "1" || agendaItem.destaque === 1) && (new Date(agendaItem.data_inicio) >= yesterday || new Date(agendaItem.data_fim) >= yesterday)) {
            return agendaItem
            } else {
            return false
            }
        })
    

    return (
        <>        
           {(!loading || AgendaCache !== null) ?
            <>
                 <div className="timeline" ref={elmt}>
                    <div className="timeline__wrap">
                        <div className="timeline__items">
                            {agendaFilter.slice(0).reverse().map((agendaItem) => (
                                <AgendaItem key={agendaItem.event_id} agendaItem={agendaItem} lang={lang} />
                            ))}                         
                        </div>
                    </div>
                </div>
                <div className="moreEvents">
                    {lang === "pt" ?
                        <Link to={"/pt/eventos"}>Todos os Eventos</Link>
                            :
                        <Link to={"/en/events"}>All Events</Link>}
                </div>
            </> 
            : 
            <div>
                <Icon style={{fontSize: '3rem', color: '#dc2f2f'}} icon="iconoir:db-error" />
            </div>                
           }
        </>
    )
}

export default AgendaCache